import { isEmpty } from '@app/utils/isEmpty';
import { IconComponent } from '@typings';
import React from 'react';

import { Button } from '../various/Button';
import { Dropdown, DropdownMenu, DropdownTrigger } from '../various/Dropdown';
import { Filters } from '../various/Icons';

interface Filter<T extends string> {
  name: string;
  value: T;
  icon?: IconComponent;
}

interface Props<T extends string> {
  title: string;
  selected: T;
  filters: Filter<T>[];
  onChange: (status: T) => void;
}

export const ListFilter = React.memo(<T extends string>({ selected, filters, onChange, title }: Props<T>) => {
  const dropdownItems = React.useMemo(() => filters.map(({ name, value, icon }) => ({ icon, key: value, label: name })), [filters]);
  const selectedKeys = React.useMemo(() => [selected], [selected]);

  return (
    <Dropdown title={title} placement="bottom-start">
      <DropdownTrigger>
        {({ isOpen, triggerProps }) => (
          <Button
            aria-label={title}
            size="medium"
            variant="bordered"
            color="secondary"
            icon={Filters}
            className="pl-3 pr-2 lg:pl-6 lg:pr-5"
            isChevronOpen={isOpen}
            isActive={!isEmpty(selected)}
            {...triggerProps}
          >
            <span className="hidden lg:block">{filters.find(filter => filter.value === selected)?.name}</span>
          </Button>
        )}
      </DropdownTrigger>
      <DropdownMenu
        selectionMode="single"
        selectedKeys={selectedKeys}
        items={dropdownItems}
        onSelectionChange={([status]) => onChange(status as T)}
      />
    </Dropdown>
  );
});
